export default __webpack_public_path__ + "static/media/kosmosLanding.a93f204d.svg";